// Vendor imports
const { connect } = require('react-redux')
// Client V2 common imports
const ImmutableToJS = require('client-v2/common/components/immutable-to-js')
const PageSlicer = require('client-v2/common/components/page-slicer')
const { createFeedSmartComponent } = require('client-v2/common/containers/feed/component-smart')
// Entry imports
const discoverActions = require('./actions')
const DiscoverSection = require('./component-dumb')
const discoverSelectors = require('./selectors')

const commonFeedSmartComponent = createFeedSmartComponent(discoverActions, discoverSelectors)

const PAGE_SIZE = 15

function mapStateToProps(state, ownProps) {
  const commonFeedProps = commonFeedSmartComponent.mapStateToProps(state, ownProps)
  return {
    ...commonFeedProps,
    // Work-around https://app.asana.com/0/102902769366319/928788517144243/f
    isCollectionSubscribersCountVisible: false,
    isMoreAvailable: ownProps.isMoreAvailable && commonFeedProps.isMoreAvailable,
    pageSize: PAGE_SIZE
  }
}

module.exports = connect(
  mapStateToProps,
  commonFeedSmartComponent.mapDispatchToProps
)(
  PageSlicer(
    ImmutableToJS(
      DiscoverSection
    )
  )
)
